export default __webpack_public_path__ + "static/media/swipe-philanthropy.858e3341.png";